var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryTitleIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1668 3.16666H9.50016C8.66031 3.16666 7.85486 3.50029 7.26099 4.09415C6.66713 4.68802 6.3335 5.49347 6.3335 6.33332V31.6667C6.3335 32.5065 6.66713 33.312 7.26099 33.9058C7.85486 34.4997 8.66031 34.8333 9.50016 34.8333H28.5002C29.34 34.8333 30.1455 34.4997 30.7393 33.9058C31.3332 33.312 31.6668 32.5065 31.6668 31.6667V12.6667L22.1668 3.16666Z",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.1665 3.16666V12.6667H31.6665",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.3332 20.5833H12.6665",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.3332 26.9167H12.6665",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8332 14.25H14.2498H12.6665",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryTitleIc);
export default __webpack_public_path__ + "static/media/library_title_ic.c40a7b6d6b896e9e6c42055c1a0918d4.svg";
export { ForwardRef as ReactComponent };